import { z } from "zod/mini"

export const StringLegacySchema = z.pipe(
	z.string(),
	z.transform((s: string) => s.trim()),
)

export type StringLegacy = z.infer<typeof StringLegacySchema>
